<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
	background-color: #419FFF;
	border-radius: 2px;
}
</style>

<template>
	<div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{ $t('liangtaijijiadonglv') }}
				</p>
			</div>

		</div>
		<div id="xiangjiaoMonitorJiadonglvchart" :style="{ 'height': chartHeight + 'px' }">


		</div>

	</div>

</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_efficiency_all',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			timer: null,
			chart: null,
			option: null,
			chartHeight: 0,
		};
	},
	created() {
		this.timer = setInterval(() => {
			this.makeData()
		}, 600000)
	},

	watch: {
		datas: {
			handler(n, o) {
				if (n != o) {
					this.makeData()
				}
			},
			deep: true
		}
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeData()

	},


	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	},
	methods: {
		makeData() {
			this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
				20
			if (!this.chart) {
				setTimeout(() => {
					this.initChart()
					this.makeData()
				}, 100)
			} else {



				let dates = Object.keys(this.datas["YL2-H300F"].runTimeRateMap)
				//dates年月日从小到大排序
				dates.sort((a, b) => {
					let aDate = new Date(a)
					let bDate = new Date(b)
					return aDate - bDate
				})
				//dates只取2025-10-08和之后的
				dates = dates.filter(item =>
					item >= "2025-10-08"
				)
				console.log(dates)
				let runTimeRates1 = []
				let runTimeRates2 = []
				let runTimeTime1 = []
				let runTimeTime2 = []
				let runTimeRatesAll = []


				dates.forEach(item => {
					runTimeTime1.push(this.datas["YL2-H300F"].runTimeMap[item])
					runTimeTime2.push(this.datas["YL3-V440F"].runTimeMap[item])
					runTimeRates1.push(this.datas["YL2-H300F"].runTimeRateMap[item])
					runTimeRates2.push(this.datas["YL3-V440F"].runTimeRateMap[item])
				})



				//只取日
				dates = dates.map(item => {
					let m = item.split("-")[1]
					let d = item.split("-")[2]
					if (m[0] == '0') {
						m = m[1]
					}
					if (d[0] == '0') {
						d = d[1]
					}

					return m + "/" + d
				})

				for (let i = 0; i < runTimeRates1.length; i++) {
					runTimeRatesAll.push(parseFloat(runTimeRates1[i]) + parseFloat(runTimeRates2[i]) / 2)
				}

				let size = dates.length

				//runTimeTime1,runTimeTime2,runTimeRatesAll，都只取最后size个
				runTimeTime1 = runTimeTime1.slice(-size)
				runTimeTime2 = runTimeTime2.slice(-size)
				runTimeRatesAll = runTimeRatesAll.slice(-size)


				//runTimeTime1,runTimeTime2最大为9
				runTimeTime1 = runTimeTime1.map(item => {
					if (item > 9) {
						item = 9
					}
					return item
				})
				runTimeTime2 = runTimeTime2.map(item => {
					if (item > 9) {
						item = 9
					}
					return item
				})

				let sumRunTime = runTimeTime1.reduce((a, b) => a + b, 0) + runTimeTime2.reduce((a, b) => a + b, 0)
				this.utils.event_hub.$emit('xiangjiaoSumRunTime', sumRunTime)


				this.option.xAxis.data = dates;
				this.option.series[0].data = runTimeTime1;
				this.option.series[1].data = runTimeTime2;
				this.option.series[2].data = runTimeRatesAll;
				this.chart.setOption(this.option)
			}

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.titleBar) {
					return;
				}
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
					20
				if (!this.chart) {
					return;
				}
				this.chart.getDom().style.height = this.chartHeight + "px";
				this.chart.resize()

			}, 800)
		},
		initChart() {
			this.option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						label: {
							formatter: '{value} '
						},
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
					},
					backgroundColor: 'rgba(0,0,0,0.8)',
					borderWidth: 0,
					textStyle: {
						color: "#C0C4CC",
					},
					formatter: function (params) {
						let result = params[0].name + '<br/>';
						params.forEach(function (item) {
							if (item.seriesIndex === 2) { // 折线图（第三个series）
								result += item.marker + item.seriesName + ': ' + item.value + '%<br/>';
							} else { // 柱状图
								result += item.marker + item.seriesName + ': ' + item.value + ' h<br/>';
							}
						});
						return result;
					}
				},
				grid: {
					left: '0',
					right: '0',
					bottom: '0',
					top: '30',
					containLabel: true,
				},
				legend: {
					left: 'center',
					top: '0%',
					textStyle: {
						color: '#FFFFFF',
						fontSize: 12,
					},
					itemWidth: 15,
					itemHeight: 10,
					itemGap: 25,
				},
				dataZoom: [{
					show: false,
					height: 8,
					xAxisIndex: [0],
					bottom: 0,
					start: 0,
					end: 100,
					handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
					handleSize: '100%',
					handleStyle: {
						color: 'rgba(255, 255, 255,1',
					},
					textStyle: {
						color: "transparent",
						fontSize: 12,
					},
					fillerColor: '#CBCED4',
					borderColor: 'transparent',
					backgroundColor: 'transparent',
					showDataShadow: false,
					brushSelect: false,
				},
				{
					type: 'inside',
					disabled: false,
				},
				],
				xAxis: {
					show: true,
					type: 'category',
					name: '',
					nameLocation: 'end',
					nameTextStyle: {
						fontSize: 12,
					},
					inverse: false,
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#000',
							width: 1,
						},
					},
					axisTick: {
						show: true,
						alignWithLabel: false,
						interval: 'auto',
						inside: false,
						length: 5,
						lineStyle: {
							type: 'solid',
							width: 1,
							color: '#909399',
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							width: 1,
							color: '#909399',
						},
					},
					axisLabel: {
						margin: 8,
						interval: 'auto',
						rotate: 0,
						fontSize: 12,
						color: '#C0C4CC',
					},
					data: [],
				},
				yAxis: [{
					show: true,
					type: 'value',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} h',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}, {
					show: true,
					type: 'value',
					position: 'right',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} %',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}],
				series: [{
					name: this.$t('YL2-H300F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FD9DFF',
							},
							{
								offset: 1,
								color: '#4F32FF',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				},
				{
					name: this.$t('YL3-V440F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#419FFF',
						position: 'top',
						fontSize: 12,
					},
					// data: this.efficiencies.runTimeRates,
					data: [],
					// runRate

				},
				{
					name: this.$t('jiadonglv_xiangjiaoji'),
					yAxisIndex: 1,
					type: 'line',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#A1FE79',
							},
							{
								offset: 1,
								color: '#A1FE79',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				}
				],


			};
			var chartDom = document.getElementById('xiangjiaoMonitorJiadonglvchart');
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		}
	}
};
</script>
